<template>
    <div class="header">
		<img src="../../../assets/img/common/icon.png" alt="">
		<h3>信安天途</h3>
    </div>
</template>

<script>
export default {
    data() {
        return {
			
        };
    },
    mounted() {
        
    },
    methods: {
 
		
    },
};
</script>

<style scoped lang='scss'>
	.header{
		position: fixed;
		top: 0PX;
		left: 0PX;
		width:100% ;
		height: 60PX;
		background-color: rgba(1, 101, 137, 0.47);
		display: flex;
		align-items: center;
		box-sizing: border-box;
		img{
			width: 50PX;
			height: 50PX;
			border-radius: 50%;
			margin-right: 10PX;
			margin-left: 20PX;
		}
		h3{
			color: #fff;
			font-size: 28PX;
			font-weight: bolder;
		}
	}

</style>
